import React from "react";
import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "./ModalFooter";

class PromptModal extends React.PureComponent {
  render() {
    const {
      isOpenModal,
      handleConfirm,
      handleCancel,
      handleClose,
      header,
      children,
      msg,
      isLoading = false,
      redo = true,
      width = "30%",
    } = this.props;

    return (
      <ModalWrapper
        isOpen={isOpenModal}
        showCloseFooter={false}
        customOverlayStyle={{ zIndex: 100 }}
        width={width}
        title={header || "Caution"}
      >
        <div>
          <div
            className="mb-4 overflow-y-auto text-gray-600"
            style={{ maxHeight: "600px" }}
          >
            {children}
          </div>

          <ModalFooter
            msg={msg}
            isLoading={isLoading}
            redo={redo}
            onClose={handleClose}
            onCancel={handleCancel}
            onConfirm={handleConfirm}
          ></ModalFooter>
        </div>
      </ModalWrapper>
    );
  }
}

export default PromptModal;
